import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

@Component({
  selector: 'app-profile',
  imports: [CommonModule],
  templateUrl: './profile.component.html',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0, transform: 'translateY(0)' }), animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))]),
      transition(':leave', [animate('100ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class ProfileComponent {
  @Input() id: string = '';
  @Input() isSideMenu = false;

  private authService = inject(AuthService);
  private router = inject(Router);

  isProfileOpen = false;
  name = this.authService.currentUser()?.fullName;

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (this.isProfileOpen && !this.elementRef.nativeElement.contains(event.target)) {
      this.isProfileOpen = false;
    }
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/auth']);
  }
}
